export enum LocalStorageKeyType { // Naming convention like this: TCG_LS...
    CookiePreference =          `TCG_LS_COOKIE_PREFERENCE`
}